import Modal from 'components/modal'
import { IconClose } from '@tracklib/kit'
import { getYoutubeIdFromUrl } from '@constants'
import styles from './videomodal.css'

type VideoModalProps = {
  videoUrl: string
  isOpen: boolean
  closeModal: () => void
}

const VideoModal = ({ videoUrl, isOpen, closeModal }: VideoModalProps): JSX.Element => {
  const videoSrc = `https://www.youtube.com/embed/${getYoutubeIdFromUrl(
    videoUrl,
  )}?modestbranding=1&autoplay=1&iv_load_policy=3&rel=0&showinfo=0&color=white&fs=1&disablekb=1`

  if (isOpen) {
    return (
      <Modal isOpen onCancel={closeModal} onClose={closeModal} className={styles.videoModal} fullscreen>
        <div className={styles.closeButtonWrapper}>
          <IconClose datatesting="close_video_button" className={styles.modalClose} onClick={closeModal} />
        </div>
        <div className={styles.video}>
          <iframe src={videoSrc} frameBorder="0" title="video" />
        </div>
      </Modal>
    )
  }
  return null
}

export default VideoModal
